import { useCallback, useEffect, useRef, useState } from "react";
import { getHub, type Hub, ApiError } from "../lib/api";

/**
 * Поллинг состояния хаба гостя раз в 10 секунд.
 * Гость видит отметки тренера, греблю и приз почти в реальном времени.
 * Возвращает hub, ошибку и функцию reload() для мгновенного обновления
 * (например, после создания/вступления в клан или получения приза).
 */
export function useHub(phone: string | null) {
  const [hub, setHub] = useState<Hub | null>(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);
  const aliveRef = useRef(true);

  const tick = useCallback(async () => {
    if (!phone) return;
    try {
      const h = await getHub();
      if (aliveRef.current) {
        setHub(h);
        setError("");
      }
    } catch (e: any) {
      // Сохраняем код ошибки (а не текст) — страница сама локализует его.
      if (aliveRef.current) setError(e instanceof ApiError ? e.code : "error");
    } finally {
      if (aliveRef.current) setLoading(false);
    }
  }, [phone]);

  useEffect(() => {
    aliveRef.current = true;
    if (!phone) {
      setLoading(false);
      return;
    }
    setLoading(true);
    tick();
    timer.current = setInterval(tick, 10000);

    return () => {
      aliveRef.current = false;
      if (timer.current) clearInterval(timer.current);
    };
  }, [phone, tick]);

  return { hub, error, loading, reload: tick };
}
